import { CSSProperties } from 'react';
import { DeepTx } from '../../txHelpers';
import { tokens } from '../../tokens';
import DeepRow from './DeepRow';
import SummaryPanel from './SummaryPanel';

interface Props {
  tx: DeepTx;
  /** Collapse handler — wired to the summary panel header. */
  onCollapse?: () => void;
}

const sectionHeading: CSSProperties = {
  fontSize: 12,
  color: tokens.textPrimary,
  fontFamily: tokens.fontMono,
  letterSpacing: '0.18em',
  marginBottom: 6,
  fontWeight: 700,
};

const divider: CSSProperties = {
  borderTop: '1px solid rgba(255,255,255,0.1)',
};

/**
 * Shared rail content for both expanded transaction views (standard and MRC
 * deep dive): summary panel, quantities & balances, fees. Returned as a
 * fragment so the parent rail's responsive gap spaces the sections — keeping
 * the two views byte-identical.
 */
const ExpandedRailInfo = ({ tx, onCollapse }: Props) => (
  <>
    <SummaryPanel tx={tx} onHeaderClick={onCollapse} />

    <div style={divider} />

    <div>
      <div style={sectionHeading}>QUANTITIES &amp; BALANCES</div>
      <DeepRow label="Stable quantity" value={tx.stableQty} />
      <DeepRow label="Asset quantity" value={tx.assetQty} />
      <DeepRow label="Stable balance" value={tx.stableBal} />
      <DeepRow label="Asset balance" value={tx.assetBal} />
      {tx.extraStat && (
        <DeepRow
          label={tx.extraStat.label}
          value={tx.extraStat.value}
          color={tokens.textMuted}
        />
      )}
    </div>

    <div style={divider} />

    <div>
      <div style={sectionHeading}>FEES</div>
      <DeepRow label="Fee value" value={tx.fee} />
      <DeepRow
        label="Total fees paid"
        value={tx.totalFees}
        color={tokens.textTertiary}
      />
    </div>
  </>
);

export default ExpandedRailInfo;
